import React from 'react';
import { MobileConsultationView } from '../types/consultationPage.types';
import ConsultationBackButton from './ConsultationBackButton';
import MobileBottomNav from './MobileBottomNav';
import styles from '../styles.module.scss';

type Props = {
  scroll: boolean;
  isVisible: boolean;
  backPath: string;
  goToDashboard: () => void;
  roleNavigate: (path: string) => void;
  mobileView: MobileConsultationView;
  setMobileView: (view: MobileConsultationView) => void;
  caseContent: React.ReactNode;
  patientInfo: React.ReactNode;
  careTeam: React.ReactNode;
};

const ConsultationMobileLayout = ({
  scroll,
  isVisible,
  backPath,
  goToDashboard,
  roleNavigate,
  mobileView,
  setMobileView,
  caseContent,
  patientInfo,
  careTeam,
}: Props): JSX.Element => {
  return (
    <div className={styles.mobileConsultationLayout}>
{/*       <ConsultationBackButton
        sticky={scroll}
        onClick={() => {
          if (isVisible) {
            goToDashboard();
            return;
          }

          roleNavigate(backPath);
        }}
      /> */}

      <div className={styles.mobileConsultationContent}>
        {mobileView === 'case' ? <div className={styles.consultationPageRightSide}>{caseContent}</div> : null}
        {mobileView === 'patient-info' ? <div className={styles.consultationPageLeftSide}>{patientInfo}</div> : null}
        {mobileView === 'care-team' ? <div className={styles.consultationPageLeftSide}>{careTeam}</div> : null}
      </div>

      <MobileBottomNav mobileView={mobileView} setMobileView={setMobileView} />
    </div>
  );
};

export default ConsultationMobileLayout;